import styled from '@emotion/styled';
import { Card } from '@material-ui/core';

export const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  flex-direction: column;
`;

export const StandardBox = styled(Card)`
  min-height: 350px;
  height: auto;
  width: 300px;
  color: #666666 !important;
  margin: 0 auto;
  text-align: center;
  padding: 30px;
  display: flex;
  flex-direction: column;
  overflow: ${props => (props.showoverflow ? 'visible !important' : 'inherit')};
`;

export const WideBox = styled(Card)`
  min-height: 350px;
  height: auto;
  min-width: 300px;
  max-width: 900px;
  width: 80%;
  color: #666666 !important;
  margin: 0 auto;
  text-align: center;
  padding: 30px;
  display: flex;
  flex-direction: column;
  margin: 1rem;
  overflow: ${props => (props.showoverflow ? 'visible !important' : 'inherit')};
`;

export const ModalBox = styled(Card)`
  height: auto;
  min-width: 300px;
  max-width: 900px;
  width: 80%;
  color: #666666 !important;
  margin: 0 auto;
  text-align: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: none !important;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LoginBox = styled(Card)`
  min-height: 350px;
  width: 300px;
  color: #666666 !important;
  margin: 0 auto;
  text-align: center;
  padding: 30px;
  display: flex;
  flex-direction: column;
`;

export const OrgOption = styled.p`
  color: #108772 !important;
  cursor: pointer;
`;

export const NewOrg = styled.h4`
  color: #108772 !important;
  cursor: pointer;
`;

export const CancelOrg = styled.h4`
  color: #de1018 !important;
  cursor: pointer;
`;

export const ErrorText = styled.div`
  color: #f44336;
  font-size: 14px;
  text-align: left;
  width: 100%;
`;

export const ButtonFlex = styled.div`
  display: flex;
  margin-top: 1.2rem;
  justify-content: flex-end;
  & > button,
  a {
    margin: 5px;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const RowItem = styled.div`
  width: inherit;
`;
